import {UploadOutlined} from '@ant-design/icons'
import {Button, message, Upload} from 'antd'
import {NullAsDefault} from "views/Shared";
import {Field} from 'formik'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {createValue} from '../utils'
import Resizer from "react-image-file-resizer";
import ImageCropModal from "./ImageCropModal";

export const getBase64 = (file, maxWidth, maxHeight) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            maxWidth,
            maxHeight,
            "JPEG",
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });

export function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString?.length);
    for (var i = 0; i < byteString?.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type: mimeString});
}

export default function ImageUpload({
                                        value,
                                        name,
                                        onChange,
                                        success = NullAsDefault,
                                        error = NullAsDefault,
                                        renderPreview,
                                        showUploadList = true,
                                        maxWidth = 256, maxHeight = 256,
                                        cropPurpose,
                                        cropShape,
                                        children
                                    }) {
    const translate = useTranslate();
    const [cropFile, setCropFile] = React.useState(null)


    const handleOnchange = async function (
        info
    ) {
        if (!!info && !info.file.preview) {
            // Có cropPurpose -> mở modal cắt/căn ảnh, bỏ qua resize mù ở đây.
            if (cropPurpose) {
                // eslint-disable-next-line no-console
                console.debug('[ImageUpload] open crop modal', {cropPurpose, file: info.file})
                setCropFile(info.file.originFileObj || info.file)
                return
            }
            const file = await getBase64(info.file, maxWidth, maxHeight);
            const image = dataURItoBlob(file);
            onChange(
                createValue(
                    name + '_preview',
                    file
                )
            )
            onChange(
                createValue(
                    name,
                    image
                )
            )
        }
        if (
            !!info && info.file.status !== 'uploading'
        ) {
            console.log(1,
                info.file,
                info.fileList
            )
        }
        if (!!info && info.file.status === 'done') {
            success(
                `${info.file.name} ${translate(
                    'file uploaded successfully'
                )}`
            )
        } else if (
            !!info && info.file.status === 'error'
        ) {
            !!info &&
            error(
                `${info.file.name} ${translate(
                    'file upload failed'
                )}.`
            )
        }
    }
    const beforeUpload = function beforeUpload(
        file
    ) {
        const isLt2M =
            file.size / 1024 / 1024 < 4
        if (!isLt2M) {
            message.error(
                `${translate(
                    'image must smaller than'
                )} 4MB!`
            )
        }
        const isJpgOrPng =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/webp'
        if (!isJpgOrPng) {
            message.error(
                `${translate(
                    'You can only upload JPG/PNG file'
                )}!`
            )
        }

        return false
    }
    return (
        <div className="flex flex-col gap-4 items-center">
            <Field
                name={name + '_preview'}
                render={({
                             field,
                             form: {
                                 touched = {},
                                 errors = {}
                             } = {
                                 touched: {},
                                 errors: {}
                             }
                         }) =>
                    renderPreview ? (
                        renderPreview({
                            src: field.value
                        })
                    ) : (
                        <img
                            style={{
                                width: '100%',
                                minHeight: '300px',
                                height: 'auto',
                                objectFit: 'cover'
                            }}
                            src={field.value}
                            sizes={100}
                            className="bg-gray-300"
                            alt={field.value}
                        />
                    )
                }
            />
            <Upload
                accept=".jpg,.jpeg,.png,.webp"
                {...{
                    showUploadList,
                    beforeUpload,
                    name: 'file',
                    onChange: handleOnchange
                }}>
                {children ? (
                    children
                ) : (
                    <Button>
                        <UploadOutlined/>{' '}
                        {translate(
                            'click to upload'
                        )}
                    </Button>
                )}
            </Upload>
            {cropPurpose && cropFile && (
                <ImageCropModal
                    open
                    file={cropFile}
                    purpose={cropPurpose}
                    cropShape={cropShape}
                    onCancel={() => setCropFile(null)}
                    onRemove={() => {
                        onChange(createValue(name, null))
                        onChange(createValue(name + '_preview', null))
                        setCropFile(null)
                    }}
                    onOk={({blob, base64}) => {
                        onChange(createValue(name + '_preview', base64))
                        onChange(createValue(name, blob))
                        setCropFile(null)
                    }}
                />
            )}
        </div>
    )
}
